import * as e from "zod";
//#region src/apiUrls.ts
var t = "https://order.api.myparcel.nl", n = "https://order.api.acceptance.myparcel.nl", r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", ee = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", ee);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", ee), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var ee = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, te = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ne = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, re = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ie = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (re(t, n.name)) continue;
		let e = await ee(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, ae = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : te(e.querySerializer),
	url: e.url
}), oe = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = ce(e.headers, t.headers), n;
}, se = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, ce = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? se(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, h = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, le = () => ({
	error: new h(),
	request: new h(),
	response: new h()
}), ue = te({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), de = { "Content-Type": "application/json" }, fe = (e = {}) => ({
	...r,
	headers: de,
	parseAs: "auto",
	querySerializer: ue,
	...e
}), g = ((e = {}) => {
	let t = oe(fe(), e), n = () => ({ ...t }), r = (e) => (t = oe(t, e), n()), a = le(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: ce(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ie({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: ae(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ne(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => ae({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(fe({ throwOnError: !0 })), _ = e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), v = e.object({
	city: e.string().min(1).max(100).register(e.globalRegistry, { description: "The city of the address." }),
	countryCode: _,
	street: e.string().min(1).max(100).register(e.globalRegistry, { description: "The street of the address." }),
	additionalInformation: e.string().min(1).max(100).register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().min(1).max(100).register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().min(1).max(100).register(e.globalRegistry, { description: "The state of the address." }).optional()
}).register(e.globalRegistry, { description: "A physical address." }), y = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM",
	"BOL"
]).register(e.globalRegistry, { description: "The carrier of the package." }), pe = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]).register(e.globalRegistry, { description: "The carrier to select to ship a package with." }), b = e.object({
	groups: e.array(e.object({
		description: e.string().min(1).max(50).register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().min(6).max(12).register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of weight." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: _.and(e.unknown().register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().min(1).max(150).register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), me = e.object({
	groups: e.array(e.object({
		description: e.string().min(1).max(100).register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().min(6).max(12).register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: _.and(e.unknown().register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().min(1).max(150).register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), x = e.string().min(1).max(100).register(e.globalRegistry, { description: "The customer reference of the order." }), he = e.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]).register(e.globalRegistry, { description: "The delivery type of the shipment." }), ge = e.object({
	notifyOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: e.object({ date: e.iso.date().register(e.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(e.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(e.globalRegistry, { description: "Options regarding delivery timing and notifications." }), S = e.object({
	options: ge.optional(),
	type: he.optional()
}).register(e.globalRegistry, { description: "The delivery details of the shipment." }), _e = e.object({ date: e.iso.date().register(e.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(e.globalRegistry, { description: "The drop-off details." }), C = e.object({
	currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
}).register(e.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), ve = e.enum(["EU", "NON_EU"]).register(e.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), w = e.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]).register(e.globalRegistry, { description: "The status of the order." }), T = e.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]).register(e.globalRegistry, { description: "The type of the package." }), ye = e.union([
	e.object({
		group: e.enum(["PICKING_AND_PACKING"]),
		name: e.enum(["PACKED"])
	}),
	e.object({
		group: e.enum(["DISPATCHING"]),
		name: e.enum(["READY_TO_SHIP"])
	}),
	e.object({
		group: e.enum(["DISPATCHING"]),
		name: e.enum(["LABELED"])
	}),
	e.object({
		group: e.enum(["DISPATCHING"]),
		name: e.enum(["HANDED_OVER"])
	}),
	e.object({
		group: e.enum(["UNTRACEABLE"]),
		name: e.enum(["LABELED"])
	}),
	e.object({
		group: e.enum(["SORTING"]),
		name: e.enum(["IN_SORTING_PROCESS"])
	}),
	e.object({
		group: e.enum(["DISTRIBUTING"]),
		name: e.enum(["OUT_FOR_DELIVERY"])
	}),
	e.object({
		group: e.enum(["DISTRIBUTING"]),
		name: e.enum(["AT_CUSTOMS"])
	}),
	e.object({
		group: e.enum(["DISTRIBUTING"]),
		name: e.enum(["AT_PICKUP_POINT"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["AT_AGREED_LOCATION"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["AT_RECIPIENT"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["AT_SENDER"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["MARKED_AS"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["PICKED_UP"])
	})
]), E = e.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]).register(e.globalRegistry, { description: "The current payment status." }), be = e.object({
	height: e.object({
		unit: e.enum([
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.enum([
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The weight." }).optional(),
	width: e.object({
		unit: e.enum([
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}), D = e.object({
	height: e.object({
		unit: e.enum([
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.enum([
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The physical weight." }),
	width: e.object({
		unit: e.enum([
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}).register(e.globalRegistry, { description: "The physical dimensions." }), xe = e.union([_, ve]), O = e.enum(["OUTBOUND", "INBOUND"]).register(e.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), k = e.object({
	additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: e.object({ amount: e.object({
		currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(e.globalRegistry, { description: "The amount to insure." }) }).register(e.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: e.object({ amount: e.object({
		currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(e.globalRegistry, { description: "The amount of the contribution." }) }).register(e.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}).register(e.globalRegistry, { description: "Options applicable to shipments." }), A = e.object({ customLabelText: e.object({ text: e.string().min(1).max(45).register(e.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(e.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }).register(e.globalRegistry, { description: "Options applicable to individual packages of a shipment." }), Se = k.and(A), j = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), Ce = e.object({
	emailAddress: e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["BUSINESS"]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().min(1).max(20).register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The EORI number of the company." }).optional()
}), we = e.object({
	emailAddress: e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["PRIVATE"]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the contact person." })
}), M = e.union([e.object({ type: e.literal("BUSINESS") }).and(Ce), e.object({ type: e.literal("PRIVATE") }).and(we)]), Te = e.object({
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["BUSINESS"]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().min(1).max(20).register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: e.array(e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." })).min(1).max(5).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A business contact that supports multiple email addresses." }), Ee = e.object({
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["PRIVATE"]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: e.array(e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." })).min(1).max(5).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A private contact that supports multiple email addresses." }), N = e.union([e.object({ type: e.literal("BUSINESS") }).and(Te), e.object({ type: e.literal("PRIVATE") }).and(Ee)]), De = e.object({
	address: v.optional(),
	contact: M.optional()
}).register(e.globalRegistry, { description: "The billing details of an order." }), Oe = e.object({
	name: e.enum([
		"BOL",
		"CSCART",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]).register(e.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(e.globalRegistry, { description: "The external reference of the ecommerce platform." }), ke = e.object({
	id: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: e.string().min(3).max(50).register(e.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(e.globalRegistry, { description: "The external reference of the sales channel." }), Ae = e.object({
	source: e.enum(["SALES_CHANNEL"]),
	salesChannel: ke,
	ecommercePlatform: Oe
}), je = e.object({ source: e.enum(["MYPARCEL_SHOP"]) }).register(e.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), Me = e.object({
	source: e.enum(["IMPORT"]),
	sourceId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(e.globalRegistry, { description: "This external reference is set when the order originates from a generic ecommerce order import" }), Ne = e.union([
	e.object({ source: e.literal("SALES_CHANNEL") }).and(Ae),
	e.object({ source: e.literal("MYPARCEL_SHOP") }).and(je),
	e.object({ source: e.literal("IMPORT") }).and(Me)
]), Pe = e.object({ sourceId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(e.globalRegistry, { description: "The external reference of the order line." }), Fe = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().regex(/^shop\/.{1,250}$/).register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().regex(/^user\/.{1,250}$/).register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: E.optional(),
	barcode: e.string().min(1).max(50).register(e.globalRegistry, { description: "The barcode of the label." }),
	delayed: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).min(1).max(5).register(e.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), Ie = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().regex(/^shop\/.{1,250}$/).register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().regex(/^user\/.{1,250}$/).register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: E.optional()
}), Le = e.object({
	type: e.enum(["IMPORTED"]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: e.enum(["SALES_CHANNEL"]).register(e.globalRegistry, { description: "The origin of the note." }),
	text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." }),
	author: e.string().min(1).max(200).register(e.globalRegistry, { description: "The author of the note." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Re = e.object({
	type: e.enum(["PRINCIPAL"]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: e.string().min(1).max(100).register(e.globalRegistry, { description: "The principal who crated the note." }),
	text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." }),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), ze = e.union([e.object({ type: e.literal("IMPORTED") }).and(Le), e.object({ type: e.literal("PRINCIPAL") }).and(Re)]), P = e.union([
	e.object({
		address: v,
		location: e.object({
			name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: e.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]).register(e.globalRegistry, { description: "The bpost pickup location type." })
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The bpost pickup details." }),
	e.object({
		address: v,
		location: e.object({
			name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: e.enum(["PNPNL-01", "PNPBE-01"]).register(e.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(e.globalRegistry, { description: "The PostNL pickup details." }),
	e.object({
		address: v,
		location: e.object({
			name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The general pickup details." })
]), Be = e.object({
	carrier: y,
	direction: O,
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: T,
	recipient: e.object({
		address: v,
		contact: N
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: S.optional(),
	options: k.optional(),
	pickup: P.optional(),
	sender: e.object({
		address: v,
		contact: M
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional(),
	saveRecipientAddress: e.boolean().register(e.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
}), Ve = e.object({
	id: e.string().min(1).register(e.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: y,
	createdAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: O,
	hidden: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: T,
	recipient: e.object({
		address: v.optional(),
		contact: N.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: me.optional(),
	delivery: S.optional(),
	dropOff: _e.optional(),
	label: e.union([Fe, Ie]).optional(),
	multicollo: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: e.int().gte(2).lte(20).register(e.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(e.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: Se.optional(),
	pickup: P.optional(),
	price: C.optional(),
	sender: e.object({
		address: v,
		contact: M
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipment properties of a package." }), He = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: e.object({
		name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
		ean: e.string().min(1).max(13).register(e.globalRegistry, { description: "The EAN of the product." }).optional(),
		sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: e.uuid().register(e.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(e.globalRegistry, { description: "The product of an order line." }),
	quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: Pe.optional(),
	price: C.and(e.unknown().register(e.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(e.globalRegistry, { description: "The line of the order" }), Ue = e.object({
	customsDeclaration: b.optional(),
	options: A.optional(),
	physicalProperties: D.optional()
}), We = e.object({
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." })
	})).min(1).max(100).optional(),
	physicalProperties: D.optional()
}), Ge = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	status: ye,
	physicalProperties: be.optional(),
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity that the package contains" })
	})).min(1).max(100).register(e.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: Ve.optional()
}), Ke = e.object({
	customsDeclaration: b.optional(),
	options: A.optional(),
	physicalProperties: D.optional(),
	shipment: e.object({
		carrier: pe,
		direction: O,
		disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: T,
		recipient: e.object({
			address: v,
			contact: N
		}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: S.optional(),
		options: k.optional(),
		pickup: P.optional(),
		sender: e.object({
			address: v,
			contact: M
		}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional(),
		saveRecipientAddress: e.boolean().register(e.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
	})
}), qe = e.object({
	carrier: y.optional(),
	customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: me.optional(),
	delivery: S.optional(),
	direction: O.optional(),
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: e.int().gte(1).lte(20).optional(),
	options: Se.optional(),
	packageType: T.optional(),
	pickup: P.optional(),
	recipient: e.object({
		address: v.optional(),
		contact: N.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), Je = e.union([e.object({
	shopId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: x.optional(),
	package: Ke
}), e.object({
	shopId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: x.optional(),
	multicollo: e.object({
		packages: e.array(Ue).min(2).max(20),
		shipment: e.object({
			carrier: pe,
			direction: O,
			disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: T,
			recipient: e.object({
				address: v,
				contact: N
			}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: S.optional(),
			options: k.optional(),
			pickup: P.optional(),
			sender: e.object({
				address: v,
				contact: M
			}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional(),
			saveRecipientAddress: e.boolean().register(e.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
		})
	})
})]), Ye = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	packages: e.array(We).min(1).max(25)
}), Xe = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: b.optional(),
	options: A.optional(),
	physicalProperties: D.optional()
}), Ze = e.union([e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: Be,
	packages: e.array(Xe).min(1).max(25)
}), e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: Be,
	multicollo: e.array(Xe).min(2).max(25)
})]), Qe = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: C,
	shopId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	shortId: e.string().length(9).register(e.globalRegistry, { description: "The short ID of the order." }),
	status: w,
	assignedUserId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: De.optional(),
	customerReference: x.optional(),
	externalReferences: Ne.and(e.unknown().register(e.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: e.array(He).min(1).max(100).register(e.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: e.array(ze).min(1).max(100).register(e.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: e.array(Ge).min(1).max(25).register(e.globalRegistry, { description: "The packages of the order." }).optional(),
	rules: e.object({ setShippingPreferences: e.object({
		path: e.array(e.union([e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the rule." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the rule." })
		}), e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the rule group." }),
			condition: e.union([e.object({ countryCode: _ }), e.object({ geoAreaCode: ve })])
		})])).min(1).register(e.globalRegistry, { description: "The path of the rule." }),
		appliedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
		result: e.enum(["PRESERVE", "REPLACE"]).register(e.globalRegistry, { description: "How the rule was applied." })
	}).optional() }).register(e.globalRegistry, { description: "The rules that have been applied to the order." }).optional(),
	shipping: qe.optional()
}), F = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), I = F.and(e.object({
	type: e.enum(["urn:problem:client"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the violations." })
})), L = F.and(e.object({
	type: e.enum(["urn:problem:server"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(500).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), $e = F.and(e.object({
	type: e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), et = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." }),
		locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for adding an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
}), tt = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), nt = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		userId: e.string().min(1).max(50).register(e.globalRegistry, { description: "User to assign to these orders." })
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: e.never().optional(),
	query: e.never().optional()
}), rt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), it = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for canceling orders." }),
	path: e.never().optional(),
	query: e.never().optional()
}), at = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), ot = e.object({
	body: e.array(Je).min(1).max(50).register(e.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: e.never().optional(),
	query: e.never().optional()
}), st = e.array(e.union([
	e.object({
		status: e.literal(201),
		id: e.uuid()
	}),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per item." }), ct = e.object({
	body: e.array(Ye).min(1).max(50).register(e.globalRegistry, { description: "Body adding packages to orders" }),
	path: e.never().optional(),
	query: e.never().optional()
}), lt = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), ut = e.object({
	body: e.array(Ze).min(1).max(50).register(e.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
}), dt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), ft = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
}), pt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), mt = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." })
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for editing an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
}), ht = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), gt = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for importing an order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), _t = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), vt = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregations: e.array(w).min(1).max(7).register(e.globalRegistry, { description: "The statuses to retrieve counts for." }).optional(),
		filter: e.object({
			assignedUserId: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the user." })).min(1).max(100).optional(),
			carrier: e.array(y).min(1).max(16).optional(),
			hasAssignedUser: e.enum(["true", "false"]).register(e.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: e.enum(["true", "false"]).register(e.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(100).optional(),
			orderedAt: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<datetime>((\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\d|3[01])|(0[469]|11)-(0[1-9]|[12]\d|30)|(02)-(0[1-9]|1\d|2[0-8])))T([01]\d|2[0-3]):[0-5]\d(:[0-5]\d(\.\d+)?)?(Z|([+-]\d{2}:?\d{2})))$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).min(1).max(2).optional(),
			packageStatusGroup: e.array(e.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			])).min(1).max(6).optional(),
			packageType: e.array(T).min(1).max(7).optional(),
			price: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).min(1).max(2).optional(),
			regionCode: e.array(xe).min(1).max(100).optional(),
			salesChannelId: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the sales channel." })).min(1).max(100).optional(),
			shipmentDelayed: e.enum(["true", "false"]).register(e.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: e.array(O).min(1).max(2).optional(),
			shipmentPaymentStatus: e.array(E).min(1).max(3).optional(),
			shopId: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." })).min(1).max(100).optional(),
			status: e.array(w).min(1).max(7).optional()
		}).optional(),
		limit: e.int().gte(0).lte(50).nullish().default(50),
		pageToken: e.string().min(4).max(500).register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: e.string().min(1).max(500).register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: e.object({
			customerReference: j.optional(),
			orderedAt: j.optional(),
			price: j.optional(),
			sourceId: j.optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), yt = e.object({
	results: e.array(Qe).min(0).max(50).register(e.globalRegistry, { description: "The list of orders." }),
	total: e.object({
		relation: e.enum(["eq", "gte"]).register(e.globalRegistry, { description: "The relation of the total number of orders." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: e.object({ status: e.array(e.object({
		key: w,
		count: e.int().gte(0)
	})).optional() }).register(e.globalRegistry, { description: "Count of orders per status, scoped to the active search query and all active filters except the status filter." }).optional(),
	nextPageToken: e.string().min(1).max(500).register(e.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(e.globalRegistry, { description: "The found orders." }), bt = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		shipmentLabelsLayout: e.enum(["INTERLEAVED"]).register(e.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(e.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(20).register(e.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: e.object({ Accept: e.enum(["application/pdf", "application/pdf+print"]).register(e.globalRegistry, { description: "Use `application/pdf` to download the packing slip. Use `application/pdf+print; printer-group-id=<uuid>` to send the packing slip directly to a printer group." }) })
}), xt = e.union([e.string().register(e.globalRegistry, { description: "Packing slips PDF. Returned when `Accept: application/pdf`." }), e.void().register(e.globalRegistry, { description: "The packing slip has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), St = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(e.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: e.object({ Accept: e.enum(["application/pdf", "application/pdf+print"]).register(e.globalRegistry, { description: "Use `application/pdf` to download the picklist. Use `application/pdf+print; printer-group-id=<uuid>` to send the picklist directly to a printer group." }) })
}), Ct = e.union([e.string().register(e.globalRegistry, { description: "Picklist PDF. Returned when `Accept: application/pdf`." }), e.void().register(e.globalRegistry, { description: "The picklist has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), wt = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(e.globalRegistry, { description: "Note IDs to remove from the order." })
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for removing order notes." }),
	path: e.never().optional(),
	query: e.never().optional()
}), Tt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), Et = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: e.never().optional(),
	query: e.never().optional()
}), Dt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), Ot = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for evaluating order rules." }),
	path: e.never().optional(),
	query: e.never().optional()
}), kt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	I,
	L
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), R = e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), z = e.object({
	city: e.string().register(e.globalRegistry, { description: "The city of the address." }),
	countryCode: R,
	street: e.string().register(e.globalRegistry, { description: "The street of the address." }),
	additionalInformation: e.string().register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().register(e.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: e.string().register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().register(e.globalRegistry, { description: "The state of the address." }).optional()
}).register(e.globalRegistry, { description: "A physical address." }), B = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM",
	"BOL"
]), e.string()]).register(e.globalRegistry, { description: "The carrier of the package." }), At = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]), e.string()]).register(e.globalRegistry, { description: "The carrier to select to ship a package with." }), jt = e.object({
	groups: e.array(e.object({
		description: e.string().register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: R.and(e.unknown().register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.union([e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), e.string()]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Mt = e.object({
	groups: e.array(e.object({
		description: e.string().register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: R.and(e.unknown().register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.union([e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), e.string()]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Nt = e.string().register(e.globalRegistry, { description: "The customer reference of the order." }), Pt = e.union([e.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]), e.string()]).register(e.globalRegistry, { description: "The delivery type of the shipment." }), Ft = e.object({
	notifyOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: e.object({ date: e.iso.date().register(e.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(e.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(e.globalRegistry, { description: "Options regarding delivery timing and notifications." }), V = e.object({
	options: Ft.optional(),
	type: Pt.optional()
}).register(e.globalRegistry, { description: "The delivery details of the shipment." }), It = e.object({ date: e.iso.date().register(e.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(e.globalRegistry, { description: "The drop-off details." }), Lt = e.object({
	currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
}).register(e.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), Rt = e.union([e.enum(["EU", "NON_EU"]), e.string()]).register(e.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), H = e.union([e.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]), e.string()]).register(e.globalRegistry, { description: "The status of the order." }), U = e.union([e.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]), e.string()]).register(e.globalRegistry, { description: "The type of the package." }), zt = e.union([
	e.object({
		group: e.union([e.enum(["PICKING_AND_PACKING"]), e.string()]),
		name: e.union([e.enum(["PACKED"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISPATCHING"]), e.string()]),
		name: e.union([e.enum(["READY_TO_SHIP"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISPATCHING"]), e.string()]),
		name: e.union([e.enum(["LABELED"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISPATCHING"]), e.string()]),
		name: e.union([e.enum(["HANDED_OVER"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["UNTRACEABLE"]), e.string()]),
		name: e.union([e.enum(["LABELED"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["SORTING"]), e.string()]),
		name: e.union([e.enum(["IN_SORTING_PROCESS"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISTRIBUTING"]), e.string()]),
		name: e.union([e.enum(["OUT_FOR_DELIVERY"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISTRIBUTING"]), e.string()]),
		name: e.union([e.enum(["AT_CUSTOMS"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISTRIBUTING"]), e.string()]),
		name: e.union([e.enum(["AT_PICKUP_POINT"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["AT_AGREED_LOCATION"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["AT_RECIPIENT"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["AT_SENDER"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["MARKED_AS"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["PICKED_UP"]), e.string()])
	})
]), Bt = e.union([e.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]), e.string()]).register(e.globalRegistry, { description: "The current payment status." }), Vt = e.object({
	height: e.object({
		unit: e.union([e.enum([
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.union([e.enum([
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The weight." }).optional(),
	width: e.object({
		unit: e.union([e.enum([
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}), W = e.object({
	height: e.object({
		unit: e.union([e.enum([
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.union([e.enum([
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The physical weight." }),
	width: e.object({
		unit: e.union([e.enum([
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}).register(e.globalRegistry, { description: "The physical dimensions." }), Ht = e.union([R, Rt]), G = e.union([e.enum(["OUTBOUND", "INBOUND"]), e.string()]).register(e.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), K = e.object({
	additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: e.object({ amount: e.object({
		currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(e.globalRegistry, { description: "The amount to insure." }) }).register(e.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: e.object({ amount: e.object({
		currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: e.int().gte(0).lte(9007199254740991).register(e.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(e.globalRegistry, { description: "The amount of the contribution." }) }).register(e.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}).register(e.globalRegistry, { description: "Options applicable to shipments." }), q = e.object({ customLabelText: e.object({ text: e.string().register(e.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(e.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }).register(e.globalRegistry, { description: "Options applicable to individual packages of a shipment." }), Ut = K.and(q), J = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), Wt = e.object({
	emailAddress: e.string().register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["BUSINESS"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().register(e.globalRegistry, { description: "The EORI number of the company." }).optional()
}), Gt = e.object({
	emailAddress: e.string().register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["PRIVATE"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().register(e.globalRegistry, { description: "The name of the contact person." })
}), Y = e.union([e.object({ type: e.literal("BUSINESS") }).and(Wt), e.object({ type: e.literal("PRIVATE") }).and(Gt)]), Kt = e.object({
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["BUSINESS"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().register(e.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: e.array(e.string().register(e.globalRegistry, { description: "An email address." })).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A business contact that supports multiple email addresses." }), qt = e.object({
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["PRIVATE"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().register(e.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: e.array(e.string().register(e.globalRegistry, { description: "An email address." })).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A private contact that supports multiple email addresses." }), X = e.union([e.object({ type: e.literal("BUSINESS") }).and(Kt), e.object({ type: e.literal("PRIVATE") }).and(qt)]), Jt = e.object({
	address: z.optional(),
	contact: Y.optional()
}).register(e.globalRegistry, { description: "The billing details of an order." }), Yt = e.object({
	name: e.union([e.enum([
		"BOL",
		"CSCART",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]), e.string()]).register(e.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: e.string().register(e.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(e.globalRegistry, { description: "The external reference of the ecommerce platform." }), Xt = e.object({
	id: e.string().register(e.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: e.string().register(e.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(e.globalRegistry, { description: "The external reference of the sales channel." }), Zt = e.object({
	source: e.union([e.enum(["SALES_CHANNEL"]), e.string()]),
	salesChannel: Xt,
	ecommercePlatform: Yt
}), Qt = e.object({ source: e.union([e.enum(["MYPARCEL_SHOP"]), e.string()]) }).register(e.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), $t = e.object({
	source: e.union([e.enum(["IMPORT"]), e.string()]),
	sourceId: e.string().register(e.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(e.globalRegistry, { description: "This external reference is set when the order originates from a generic ecommerce order import" }), en = e.union([
	e.object({ source: e.literal("SALES_CHANNEL") }).and(Zt),
	e.object({ source: e.literal("MYPARCEL_SHOP") }).and(Qt),
	e.object({ source: e.literal("IMPORT") }).and($t)
]), tn = e.object({ sourceId: e.string().register(e.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(e.globalRegistry, { description: "The external reference of the order line." }), nn = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: Bt.optional(),
	barcode: e.string().register(e.globalRegistry, { description: "The barcode of the label." }),
	delayed: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: e.array(e.string().register(e.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).register(e.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), rn = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: Bt.optional()
}), an = e.object({
	type: e.union([e.enum(["IMPORTED"]), e.string()]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: e.union([e.enum(["SALES_CHANNEL"]), e.string()]).register(e.globalRegistry, { description: "The origin of the note." }),
	text: e.string().register(e.globalRegistry, { description: "The text of the note." }),
	author: e.string().register(e.globalRegistry, { description: "The author of the note." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), on = e.object({
	type: e.union([e.enum(["PRINCIPAL"]), e.string()]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: e.string().register(e.globalRegistry, { description: "The principal who crated the note." }),
	text: e.string().register(e.globalRegistry, { description: "The text of the note." }),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), sn = e.union([e.object({ type: e.literal("IMPORTED") }).and(an), e.object({ type: e.literal("PRINCIPAL") }).and(on)]), Z = e.union([
	e.object({
		address: z,
		location: e.object({
			name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: e.union([e.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]), e.string()]).register(e.globalRegistry, { description: "The bpost pickup location type." })
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The bpost pickup details." }),
	e.object({
		address: z,
		location: e.object({
			name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: e.union([e.enum(["PNPNL-01", "PNPBE-01"]), e.string()]).register(e.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(e.globalRegistry, { description: "The PostNL pickup details." }),
	e.object({
		address: z,
		location: e.object({
			name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The general pickup details." })
]), cn = e.object({
	carrier: B,
	direction: G,
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: U,
	recipient: e.object({
		address: z,
		contact: X
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: V.optional(),
	options: K.optional(),
	pickup: Z.optional(),
	sender: e.object({
		address: z,
		contact: Y
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional(),
	saveRecipientAddress: e.boolean().register(e.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
}), ln = e.object({
	id: e.string().register(e.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: B,
	createdAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: G,
	hidden: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: U,
	recipient: e.object({
		address: z.optional(),
		contact: X.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: Mt.optional(),
	delivery: V.optional(),
	dropOff: It.optional(),
	label: e.union([nn, rn]).optional(),
	multicollo: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: e.int().gte(2).lte(20).register(e.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(e.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: Ut.optional(),
	pickup: Z.optional(),
	price: Lt.optional(),
	sender: e.object({
		address: z,
		contact: Y
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipment properties of a package." }), un = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: e.object({
		name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
		ean: e.string().register(e.globalRegistry, { description: "The EAN of the product." }).optional(),
		sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: e.uuid().register(e.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(e.globalRegistry, { description: "The product of an order line." }),
	quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: tn.optional(),
	price: Lt.and(e.unknown().register(e.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(e.globalRegistry, { description: "The line of the order" }), dn = e.object({
	customsDeclaration: jt.optional(),
	options: q.optional(),
	physicalProperties: W.optional()
}), fn = e.object({
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." })
	})).optional(),
	physicalProperties: W.optional()
}), pn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	status: zt,
	physicalProperties: Vt.optional(),
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity that the package contains" })
	})).register(e.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: ln.optional()
}), mn = e.object({
	customsDeclaration: jt.optional(),
	options: q.optional(),
	physicalProperties: W.optional(),
	shipment: e.object({
		carrier: At,
		direction: G,
		disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: U,
		recipient: e.object({
			address: z,
			contact: X
		}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: V.optional(),
		options: K.optional(),
		pickup: Z.optional(),
		sender: e.object({
			address: z,
			contact: Y
		}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional(),
		saveRecipientAddress: e.boolean().register(e.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
	})
}), hn = e.object({
	carrier: B.optional(),
	customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: Mt.optional(),
	delivery: V.optional(),
	direction: G.optional(),
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: e.int().gte(1).lte(20).optional(),
	options: Ut.optional(),
	packageType: U.optional(),
	pickup: Z.optional(),
	recipient: e.object({
		address: z.optional(),
		contact: X.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), gn = e.union([e.object({
	shopId: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Nt.optional(),
	package: mn
}), e.object({
	shopId: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Nt.optional(),
	multicollo: e.object({
		packages: e.array(dn),
		shipment: e.object({
			carrier: At,
			direction: G,
			disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: U,
			recipient: e.object({
				address: z,
				contact: X
			}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: V.optional(),
			options: K.optional(),
			pickup: Z.optional(),
			sender: e.object({
				address: z,
				contact: Y
			}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional(),
			saveRecipientAddress: e.boolean().register(e.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
		})
	})
})]), _n = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	packages: e.array(fn)
}), vn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: jt.optional(),
	options: q.optional(),
	physicalProperties: W.optional()
}), yn = e.union([e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: cn,
	packages: e.array(vn)
}), e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: cn,
	multicollo: e.array(vn)
})]), bn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: Lt,
	shopId: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	shortId: e.string().register(e.globalRegistry, { description: "The short ID of the order." }),
	status: H,
	assignedUserId: e.string().register(e.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: Jt.optional(),
	customerReference: Nt.optional(),
	externalReferences: en.and(e.unknown().register(e.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: e.array(un).register(e.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: e.array(sn).register(e.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: e.array(pn).register(e.globalRegistry, { description: "The packages of the order." }).optional(),
	rules: e.object({ setShippingPreferences: e.object({
		path: e.array(e.union([e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the rule." }),
			name: e.string().register(e.globalRegistry, { description: "The name of the rule." })
		}), e.object({
			id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the rule group." }),
			condition: e.union([e.object({ countryCode: R }), e.object({ geoAreaCode: Rt })])
		})])).register(e.globalRegistry, { description: "The path of the rule." }),
		appliedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
		result: e.union([e.enum(["PRESERVE", "REPLACE"]), e.string()]).register(e.globalRegistry, { description: "How the rule was applied." })
	}).optional() }).register(e.globalRegistry, { description: "The rules that have been applied to the order." }).optional(),
	shipping: hn.optional()
}), xn = e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), Q = xn.and(e.object({
	type: e.union([e.enum(["urn:problem:client"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the violations." })
})), $ = xn.and(e.object({
	type: e.union([e.enum(["urn:problem:server"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(500).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
xn.and(e.object({
	type: e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		text: e.string().register(e.globalRegistry, { description: "The text of the note." }),
		locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).register(e.globalRegistry, { description: "Body for adding an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Sn = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		userId: e.string().register(e.globalRegistry, { description: "User to assign to these orders." })
	})).register(e.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Cn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for canceling orders." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var wn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(gn).register(e.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Tn = e.array(e.union([
	e.object({
		status: e.literal(201),
		id: e.uuid()
	}),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per item." });
e.object({
	body: e.array(_n).register(e.globalRegistry, { description: "Body adding packages to orders" }),
	path: e.never().optional(),
	query: e.never().optional()
});
var En = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(yn).register(e.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Dn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).register(e.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
});
var On = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: e.string().register(e.globalRegistry, { description: "The text of the note." })
	})).register(e.globalRegistry, { description: "Body for editing an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var kn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for importing an order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var An = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregations: e.array(H).register(e.globalRegistry, { description: "The statuses to retrieve counts for." }).optional(),
		filter: e.object({
			assignedUserId: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the user." })).optional(),
			carrier: e.array(B).optional(),
			hasAssignedUser: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).optional(),
			orderedAt: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).optional(),
			packageStatusGroup: e.array(e.union([e.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			]), e.string()])).optional(),
			packageType: e.array(U).optional(),
			price: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).optional(),
			regionCode: e.array(Ht).optional(),
			salesChannelId: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the sales channel." })).optional(),
			shipmentDelayed: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: e.array(G).optional(),
			shipmentPaymentStatus: e.array(Bt).optional(),
			shopId: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." })).optional(),
			status: e.array(H).optional()
		}).optional(),
		limit: e.int().gte(0).lte(50).nullish().default(50),
		pageToken: e.string().register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: e.string().register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: e.object({
			customerReference: J.optional(),
			orderedAt: J.optional(),
			price: J.optional(),
			sourceId: J.optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
});
var jn = e.object({
	results: e.array(bn).register(e.globalRegistry, { description: "The list of orders." }),
	total: e.object({
		relation: e.union([e.enum(["eq", "gte"]), e.string()]).register(e.globalRegistry, { description: "The relation of the total number of orders." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: e.object({ status: e.array(e.object({
		key: H,
		count: e.int().gte(0)
	})).optional() }).register(e.globalRegistry, { description: "Count of orders per status, scoped to the active search query and all active filters except the status filter." }).optional(),
	nextPageToken: e.string().register(e.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(e.globalRegistry, { description: "The found orders." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		shipmentLabelsLayout: e.union([e.enum(["INTERLEAVED"]), e.string()]).register(e.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).register(e.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).register(e.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: e.object({ Accept: e.union([e.enum(["application/pdf", "application/pdf+print"]), e.string()]).register(e.globalRegistry, { description: "Use `application/pdf` to download the packing slip. Use `application/pdf+print; printer-group-id=<uuid>` to send the packing slip directly to a printer group." }) })
});
var Mn = e.union([e.string().register(e.globalRegistry, { description: "Packing slips PDF. Returned when `Accept: application/pdf`." }), e.void().register(e.globalRegistry, { description: "The packing slip has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]);
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).register(e.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: e.object({ Accept: e.union([e.enum(["application/pdf", "application/pdf+print"]), e.string()]).register(e.globalRegistry, { description: "Use `application/pdf` to download the picklist. Use `application/pdf+print; printer-group-id=<uuid>` to send the picklist directly to a printer group." }) })
});
var Nn = e.union([e.string().register(e.globalRegistry, { description: "Picklist PDF. Returned when `Accept: application/pdf`." }), e.void().register(e.globalRegistry, { description: "The picklist has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]);
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(e.globalRegistry, { description: "Note IDs to remove from the order." })
	})).register(e.globalRegistry, { description: "Body for removing order notes." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Pn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Fn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for evaluating order rules." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var In = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." }), Ln = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await et.parseAsync(e),
	responseValidator: async (e) => await Sn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/add-note",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Rn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await nt.parseAsync(e),
	responseValidator: async (e) => await Cn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/assign-to-user",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), zn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await it.parseAsync(e),
	responseValidator: async (e) => await wn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/cancel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Bn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await ot.parseAsync(e),
	responseValidator: async (e) => await Tn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-from-shippable-packages",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Vn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await ct.parseAsync(e),
	responseValidator: async (e) => await En.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/add-packages",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Hn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await ut.parseAsync(e),
	responseValidator: async (e) => await Dn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/prepare-packages-for-shipment",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Un = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await ft.parseAsync(e),
	responseValidator: async (e) => await On.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/unprepare-packages-for-shipment",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Wn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await mt.parseAsync(e),
	responseValidator: async (e) => await kn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/edit-note",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Gn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await gt.parseAsync(e),
	responseValidator: async (e) => await An.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/import",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Kn = (e) => (e?.client ?? g).get({
	requestValidator: async (e) => await vt.parseAsync(e),
	responseValidator: async (e) => await jn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/orders",
	...e
}), qn = (e) => (e.client ?? g).get({
	requestValidator: async (e) => await bt.parseAsync(e),
	responseValidator: async (e) => await Mn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/packing-slips",
	...e
}), Jn = (e) => (e.client ?? g).get({
	requestValidator: async (e) => await St.parseAsync(e),
	responseValidator: async (e) => await Nn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/picklist",
	...e
}), Yn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await wt.parseAsync(e),
	responseValidator: async (e) => await Pn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-notes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Xn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await Et.parseAsync(e),
	responseValidator: async (e) => await Fn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/unassign-from-user",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Zn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await Ot.parseAsync(e),
	responseValidator: async (e) => await In.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/evaluate-rules",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
//#endregion
export { C as $, j as $t, b as A, ut as At, je as B, F as Bt, N as C, st as Ct, _ as D, kt as Dt, we as E, Ot as Et, _e as F, Dt as Ft, bt as G, Ve as Gt, ve as H, L as Ht, Oe as I, ft as It, Ct as J, k as Jt, xt as K, O as Kt, ke as L, pt as Lt, S as M, wt as Mt, ge as N, Tt as Nt, Je as O, gt as Ot, he as P, Et as Pt, Pe as Q, qe as Qt, Ne as R, Ze as Rt, Ce as S, ot as St, Ee as T, ht as Tt, vt as U, $e as Ut, Ae as V, I as Vt, yt as W, xe as Wt, Ie as X, Be as Xt, Fe as Y, A as Yt, He as Z, Ke as Zt, v as _, lt as _t, Vn as a, Ue as at, pe as b, it as bt, Bn as c, ye as ct, Gn as d, be as dt, g as en, ze as et, Hn as f, D as ft, Ye as g, ct as gt, Un as h, tt as ht, Ln as i, w as it, me as j, dt as jt, x as k, _t as kt, Wn as l, T as lt, Xn as m, et as mt, qn as n, t as nn, Re as nt, Rn as o, We as ot, Yn as p, P as pt, St as q, Se as qt, Jn as r, Qe as rt, zn as s, Ge as st, Kn as t, n as tn, Le as tt, Zn as u, E as ut, De as v, nt as vt, Te as w, mt as wt, M as x, at as xt, y, rt as yt, Me as z, Xe as zt };
